import { format } from "date-fns";
import { convertToSearchParams } from "@/components/FilterComponent/helpers";
import { FILTER_MAPPING } from "@/helpers/constants";
import routes, { resourcesType } from "@/helpers/router";

const dateToString = (date: Date, formatString: string = "yyyy-MM-dd"): string => {
  return format(date, formatString);
};

const nthNumber = (number: number): string => {
  return number > 0 ? ["th", "st", "nd", "rd"][(number > 3 && number < 21) || number % 10 > 3 ? 0 : number % 10] : "";
};

const isURL: (urlString: string) => boolean = (urlString) => {
  try {
    new URL(urlString);

    return true;
  } catch (_) {
    return false;
  }
};

const getPlainTexts = (input: any) => {
  return input
    ?.replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    ?.trim();
};

const isPhoneNumberValid = (number: string) => {
  const isValidNumber = !/^[6-9]{1}\d{0,9}$/.test(number) ? (!/^(234){1}\d{0,9}$/.test(number) ? false : true) : true;

  return isValidNumber;
};

const getNavBarInfoForCategoryRouting = (navBarData) => {
  return navBarData?.map((data) => data?.attributes);
};

const getResourceListingURL: (filters: any, resourceType?: resourcesType, page?: number) => string = (
  filters,
  resourceType,
  page
) => {
  const { searchParams, singleFilter, appliedFilters } = convertToSearchParams(filters);
  const queryParams = searchParams?.toString();

  let url = "";

  if (singleFilter) {
    url = routes.resourcesListing(appliedFilters?.[0], resourceType, page);
  } else {
    url = `${routes.resourcesListing(undefined, resourceType, page)}${queryParams ? `?${queryParams}` : ""}`;
  }

  return url;
};

export {
  dateToString,
  nthNumber,
  isURL,
  getPlainTexts,
  isPhoneNumberValid,
  getNavBarInfoForCategoryRouting,
  getResourceListingURL,
};
